/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AccessTokenExpirationTimeDto = {
    timeUnit: AccessTokenExpirationTimeDto.timeUnit;
    value: number;
};

export namespace AccessTokenExpirationTimeDto {

    export enum timeUnit {
        DAY = 'DAY',
        WEEK = 'WEEK',
        MONTH = 'MONTH',
    }


}
